<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website', 'roles', 'aos'],
    data() {
      return {
        editing: {},

        default_content: {
          type: 'site-footer',
          pre_title: 'We are here to help',
          pre_desc: 'Whether you are buying or selling our team of professionals are ready to help.',
          pre_text: 'Contact us',
          pre_color: 'revinre',
          pre_url: '/contact',
          logo: '/images/revinre-header-1.png',
          logo_alt: 'Revinre',
          logo_url: '/',
          desc: 'REVINRE exposes what really works to affect a sale and gives it all to any seller.',
          menu_1_title: 'Quicklinks',
          menu_1: [
            {name: 'Selling', slug: '/selling', auth: 0, roles: []},
            {name: 'Buying', slug: '/buying', auth: 0, roles: []},
            {name: 'Sign in', slug: '/login', auth: 0, roles: []}
          ],
          menu_2_title: 'Services',
          menu_2: [
            {name: 'Packages & Services', slug: '/how-it-works', auth: 0, roles: []},
            {name: 'Home valuation', slug: '/valuation', auth: 0, roles: []},
            {name: 'Preferred partners', slug: '/partners', auth: 0, roles: []}
          ],
          menu_3_title: 'About',
          menu_3: [
            {name: 'About Us', slug: '/how-it-works', auth: 0, roles: []},
            {name: 'How it works', slug: '/how-it-works', auth: 0, roles: []},
            {name: 'Contact us', slug: '/contact', auth: 0, roles: []}
          ],
          menu_base: [
            {name: 'Privacy policy', slug: '/privacy', auth: 0, roles: []},
            {name: 'Terms & Conditions', slug: '/terms', auth: 0, roles: []},
            {name: 'Refund & Cancellation Policy', slug: '/refund-cancel-policy', auth: 0, roles: []}
          ],
          show_phone: 1,
          show_email: 1,
          show_address: 0,
          social_icons: 1,
        },
      }
    },
    computed: {
      compRoles: function() {
        var results = [];
        for(var i in this.roles) {
          if(this.roles[i].title) { results.push({name: this.roles[i].title, value: this.roles[i].title}); }
        }
        return results;
      },
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
    },
    methods: {

    }
  }
</script>

<template>
  <div>

    <div v-if="type == 'editor'">

      <b-modal ref="modal_edit_foot_roles" centered size="lg" :title="'Edit roles'" :hide-footer="true">
        <div class="p-3">
          <div class="row">
            <div class="col-sm-6">
              <w-field SimpleDataType="String" v-model="editing.name" Title="Name :"></w-field>
            </div>
            <div class="col-sm-6">
              <w-field SimpleDataType="String" v-model="editing.slug" Title="Slug :"></w-field>
            </div>
            <div class="col-sm-6">
              <w-field SimpleDataType="String List, Single" v-model="editing.auth" Title="Require login : " :Options="[{name: 'Yes', value: 1}, {name: 'No', value: 0}]"></w-field>
            </div>
            <div class="col-sm-6">
              <w-field SimpleDataType="String List, Multi" v-model="editing.roles" Title="Require role(s) :" :Options="compRoles"></w-field>
            </div>
          </div>
        </div>
        <footer class="modal-footer modal-footer-custom">
          <button type="button" class="btn btn-light" @click="$refs.modal_edit_foot_roles.hide()">Close</button>
        </footer>
      </b-modal>

      <h5 class="mt-5 mb-3 text-uppercase bg-gray-200 p-3"><Icon icon="ri:book-2-line"></Icon> Website footer :</h5>
      <div class="row">
        <div class="col-sm-6">
          <w-field SimpleDataType="String" v-model="pc.pre_title" Title="Pre footer title :"></w-field>
        </div>
        <div class="col-sm-6">
          <w-field SimpleDataType="Textarea" v-model="pc.pre_desc" Title="Pre footer description :"></w-field>
        </div>
        <div class="col-sm-4">
          <w-field SimpleDataType="String" v-model="pc.pre_text" Title="Pre footer button text :"></w-field>
        </div>
        <div class="col-sm-4">
          <w-field SimpleDataType="String List, Single" v-model="pc.pre_color" Title="Pre footer button color : " :Options="theme_colors"></w-field>
        </div>
        <div class="col-sm-4">
          <w-field SimpleDataType="String" v-model="pc.pre_url" Title="Pre footer button URL :"></w-field>
        </div>
        <div class="col-sm-4">
          <w-field SimpleDataType="String" v-model="pc.logo" Title="Footer logo :"></w-field>
        </div>
        <div class="col-sm-4">
          <w-field SimpleDataType="String" v-model="pc.logo_alt" Title="Footer logo ALT :"></w-field>
        </div>
        <div class="col-sm-4">
          <w-field SimpleDataType="String" v-model="pc.logo_url" Title="Footer logo URL :"></w-field>
        </div>
        <div class="col-sm-4">
          <w-field SimpleDataType="Textarea" v-model="pc.desc" Title="Footer description :"></w-field>
        </div>
        <div class="col-sm-3">
          <w-field SimpleDataType="String List, Single" Title="Show phone :" :Options="[{name: 'Yes', value: 1},{name: 'No', value: 0}]" v-model="pc.show_phone"></w-field>
        </div>
        <div class="col-sm-3">
          <w-field SimpleDataType="String List, Single" Title="Show email :" :Options="[{name: 'Yes', value: 1},{name: 'No', value: 0}]" v-model="pc.show_email"></w-field>
        </div>
        <div class="col-sm-3">
          <w-field SimpleDataType="String List, Single" Title="Show address :" :Options="[{name: 'Yes', value: 1},{name: 'No', value: 0}]" v-model="pc.show_address"></w-field>
        </div>
        <div class="col-sm-3">
          <w-field SimpleDataType="String List, Single" Title="Show social icons :" :Options="[{name: 'Yes', value: 1},{name: 'No', value: 0}]" v-model="pc.social_icons"></w-field>
        </div>



        <div class="col-sm-12">
          <div class="form-group">
            <label>Footer menu 1</label>
            <w-field SimpleDataType="String" v-model="pc.menu_1_title" placeholder="Footer menu 1 title..."></w-field>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.menu_1">
              <transition-group tag="div">
                <div v-for="(menu, menu_i) in pc.menu_1" :key="'f1'+menu_i">
                  <div class="input-group mb-1">
                    <input type="text" class="form-control" placeholder="Item name..." v-model="menu.name">
                    <div class="input-group-append">
                      <input type="text" class="form-control" placeholder="Item slug..." v-model="menu.slug">
                      <button class="btn btn-white" type="button" v-tippy content="Edit roles" @click="editing = menu; $refs.modal_edit_foot_roles.show()" :class="menu.auth || (menu.roles && menu.roles.length) ? 'text-danger' : ''"><Icon icon="ri:shield-user-line"></Icon></button>
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.menu_1.splice(menu_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.menu_1.push({name: '', slug: '', auth: 0, roles: []})"><Icon icon="ri:add-line" height="18"></Icon> Add item</button>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label>Footer menu 2</label>
            <w-field SimpleDataType="String" v-model="pc.menu_2_title" placeholder="Footer menu 2 title..."></w-field>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.menu_2">
              <transition-group tag="div">
                <div v-for="(menu, menu_i) in pc.menu_2" :key="'f2'+menu_i">
                  <div class="input-group mb-1">
                    <input type="text" class="form-control" placeholder="Item name..." v-model="menu.name">
                    <div class="input-group-append">
                      <input type="text" class="form-control" placeholder="Item slug..." v-model="menu.slug">
                      <button class="btn btn-white" type="button" v-tippy content="Edit roles" @click="editing = menu; $refs.modal_edit_foot_roles.show()" :class="menu.auth || (menu.roles && menu.roles.length) ? 'text-danger' : ''"><Icon icon="ri:shield-user-line"></Icon></button>
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.menu_2.splice(menu_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.menu_2.push({name: '', slug: '', auth: 0, roles: []})"><Icon icon="ri:add-line" height="18"></Icon> Add item</button>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label>Footer menu 3</label>
            <w-field SimpleDataType="String" v-model="pc.menu_3_title" placeholder="Footer menu 3 title..."></w-field>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.menu_3">
              <transition-group tag="div">
                <div v-for="(menu, menu_i) in pc.menu_3" :key="'f3'+menu_i">
                  <div class="input-group mb-1">
                    <input type="text" class="form-control" placeholder="Item name..." v-model="menu.name">
                    <div class="input-group-append">
                      <input type="text" class="form-control" placeholder="Item slug..." v-model="menu.slug">
                      <button class="btn btn-white" type="button" v-tippy content="Edit roles" @click="editing = menu; $refs.modal_edit_foot_roles.show()" :class="menu.auth || (menu.roles && menu.roles.length) ? 'text-danger' : ''"><Icon icon="ri:shield-user-line"></Icon></button>
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.menu_3.splice(menu_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.menu_3.push({name: '', slug: '', auth: 0, roles: []})"><Icon icon="ri:add-line" height="18"></Icon> Add item</button>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label>Footer base menu</label>
            <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.menu_base">
              <transition-group tag="div">
                <div v-for="(menu, menu_i) in pc.menu_base" :key="'fb'+menu_i">
                  <div class="input-group mb-1">
                    <input type="text" class="form-control" placeholder="Item name..." v-model="menu.name">
                    <div class="input-group-append">
                      <input type="text" class="form-control" placeholder="Item slug..." v-model="menu.slug">
                      <button class="btn btn-white" type="button" v-tippy content="Edit roles" @click="editing = menu; $refs.modal_edit_foot_roles.show()" :class="menu.auth || (menu.roles && menu.roles.length) ? 'text-danger' : ''"><Icon icon="ri:shield-user-line"></Icon></button>
                      <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.menu_base.splice(menu_i, 1)"><Icon icon="ri:delete-bin-line"></Icon></button>
                      <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <button class="btn btn-sm btn-primary" type="button" @click="pc.menu_base.push({name: '', slug: '', auth: 0, roles: []})"><Icon icon="ri:add-line" height="18"></Icon> Add item</button>
          </div>
        </div>

      </div>
    </div>

    <footer v-else class="bg-dark text-white">
      <div class="container-fluid">
        <div v-if="website.site_footer.pre_title || website.site_footer.pre_desc || website.site_footer.pre_text" class="row">
          <div class="col-sm-12">
            <div class="py-5 mb-5 border-bottom border-black">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <h3 class="text-white mb-2" :data-aos="this.aos == false ? false : 'fade-zoom-in'">{{website.site_footer.pre_title}}</h3>
                  <p class="text-gray-600 mb-0" :data-aos="this.aos == false ? false : 'fade-zoom-in'">{{website.site_footer.pre_desc}}</p>
                </div>
                <div class="col-sm-4">
                  <div class="text-md-right" :data-aos="this.aos == false ? false : 'fade-zoom-in'">
                    <a :href="website.site_footer.pre_url" class="btn btn-lg" :class="'btn-'+website.site_footer.pre_color">{{website.site_footer.pre_text}} <Icon icon="ri:arrow-right-s-line"></Icon></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="website.site_footer.logo_url || website.site_footer.desc || (website.site_footer.menu_1 && website.site_footer.menu_1.length > 0) || (website.site_footer.menu_2 && website.site_footer.menu_2.length > 0) || (website.site_footer.menu_3 && website.site_footer.menu_3.length > 0) || website.site_footer.show_phone || website.site_footer.show_email || website.site_footer.show_address || website.site_footer.social_icons" class="row">
          <div class="col-sm-3" :data-aos="this.aos == false ? false : 'fade-zoom-in'">

            <div class="mb-2"><a :href="website.site_footer.logo_url"><img :src="formatImage(website.site_footer.logo)" :alt="website.site_footer.logo_alt" height="55"></a></div>
            <p class="text-gray-600 m-0">{{website.site_footer.desc}}</p>
            <div class="mt-2">
              <img src="/images/realtorlogo.png" alt="Equal Housing Opportunity" v-tippy content="Equal Housing Opportunity" class="_w-105">
            </div>
          </div>
          <div v-if="website.site_footer.menu_1 && website.site_footer.menu_1.length > 0" class="col-sm-2" :data-aos="this.aos == false ? false : 'fade-zoom-in'">
            <h5 class="text-white mb-3">{{website.site_footer.menu_1_title}}</h5>
            <ul class="list-unstyled font-weight-bold small">
              <li v-for="(menu, menu_i) in website.site_footer.menu_1" :key="'f1'+menu_i" class="py-2" v-if="(!menu.auth || (menu.auth && user.id)) && (!menu.roles || !menu.roles.length) || (user.id && menu.roles && hasRole(menu.roles))"><a :href="menu.slug" class="text-gray-600 text-hover-white">{{menu.name}}</a></li>
            </ul>
          </div>
          <div v-if="website.site_footer.menu_2 && website.site_footer.menu_2.length > 0" class="col-sm-2" :data-aos="this.aos == false ? false : 'fade-zoom-in'">
            <h5 class="text-white mb-3">{{website.site_footer.menu_2_title}}</h5>
            <ul class="list-unstyled font-weight-bold small">
              <li v-for="(menu, menu_i) in website.site_footer.menu_2" :key="'f2'+menu_i" class="py-2" v-if="(!menu.auth || (menu.auth && user.id)) && (!menu.roles || !menu.roles.length) || (user.id && menu.roles && hasRole(menu.roles))"><a :href="menu.slug" class="text-gray-600 text-hover-white">{{menu.name}}</a></li>
            </ul>
          </div>
          <div v-if="website.site_footer.menu_2 && website.site_footer.menu_3.length > 0" class="col-sm-2" :data-aos="this.aos == false ? false : 'fade-zoom-in'">
            <h5 class="text-white mb-3">{{website.site_footer.menu_3_title}}</h5>
            <ul class="list-unstyled font-weight-bold small">
              <li v-for="(menu, menu_i) in website.site_footer.menu_3" :key="'f3'+menu_i" class="py-2" v-if="(!menu.auth || (menu.auth && user.id)) && (!menu.roles || !menu.roles.length) || (user.id && menu.roles && hasRole(menu.roles))"><a :href="menu.slug" class="text-gray-600 text-hover-white">{{menu.name}}</a></li>
            </ul>
          </div>
          <div v-if="website.site_footer.show_phone || website.site_footer.show_email || website.site_footer.show_address || website.site_footer.social_icons" class="col-sm-3" :data-aos="this.aos == false ? false : 'fade-zoom-in'">
            <h3 class="h5 footer-title text-white mb-3">Contact</h3>
            <ul class="list-unstyled font-weight-bold small">
              <li v-if="website.site_footer.show_phone" class="py-2"><a :href="'tel:'+website.site_phone" class="text-gray-600 text-hover-white"><i class="mdi mdi-phone-outgoing"></i> {{formatPhone(website.site_phone)}}</a></li>
              <li v-if="website.site_footer.show_email" class="py-2"><a :href="'mail:'+website.site_email" class="text-gray-600 text-hover-white"><i class="mdi mdi-email-open"></i> {{website.site_email}}</a></li>
              <li v-if="website.site_footer.show_address" class="py-2"><a href="/" class="text-gray-600 text-hover-white"><i class="mdi mdi-email-open"></i> {{website.site_address}}<br>{{website.site_city}} {{website.site_state}} {{website.site_zip_code}}</a></li>
              <li v-if="website.site_footer.social_icons" class="pt-2">
                <ul class="list-inline">
                  <li v-if="website['site_facebook']" class="list-inline-item p-0 mr-3" v-tippy content="Visit us on Facebook"><a :href="website['site_facebook']" target="_blank" class="text-white"><Icon icon="ri:facebook-fill" height="20"></Icon></a></li>
                  <li v-if="website['site_instagram']" class="list-inline-item p-0 mr-3" v-tippy content="Visit us on Twitter"><a :href="website['site_instagram']" target="_blank" class="text-white"><Icon icon="ri:twitter-line" height="20"></Icon></a></li>
                  <li v-if="website['site_twitter']" class="list-inline-item p-0 mr-3" v-tippy content="Visit us on Instagram"><a :href="website['site_twitter']" target="_blank" class="text-white"><Icon icon="ri:instagram-line" height="20"></Icon></a></li>
                  <li v-if="website['site_youtube']" class="list-inline-item p-0 mr-3" v-tippy content="Visit us on YouTube"><a :href="website['site_youtube']" target="_blank" class="text-white"><Icon icon="ri:youtube-line" height="20"></Icon></a></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="py-4 text-center small">
              <ul class="list-inline text-gray-600 small">
                <li class="list-inline-item m-0">{{new Date().getFullYear()}} © {{app_name}}, LLC. All Rights Reserved</li>
                <li v-for="(menu, menu_i) in website.site_footer.menu_base" :key="'fb'+menu_i" class="list-inline-item m-0" v-if="(!menu.auth || (menu.auth && user.id)) && (!menu.roles || !menu.roles.length) || (user.id && menu.roles && hasRole(menu.roles))"> - <a :href="menu.slug" class="text-gray-600 text-hover-white">{{menu.name}}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>

  </div>
</template>
